"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AnalyticsProvider_1 = require("../AnalyticsProvider");

var ga_1 = require("./ga");

var GoogleAnalyticsProvider =
/** @class */
function (_super) {
  __extends(GoogleAnalyticsProvider, _super);

  function GoogleAnalyticsProvider(name, config) {
    var _this = _super.call(this, name) || this;

    _this.loaded = false;
    _this.config = config; // Electric will pass eventCallback, which we will use to send events in Electric’s iFrame context to Google Analytics
    // on the host page. Redline will not pass eventCallback and will load the Google Analytics script.

    if (_this.config.eventCallback === undefined && config.clientId && config.trackers.length) {
      _this.loadGA().then(function () {
        console.log("Analytics was successfully loaded");
      }).catch(function (e) {
        console.log("Unable to load Analytics.js library with error: ", e);
      });
    }

    return _this;
  }

  GoogleAnalyticsProvider.prototype.sendEvent = function (event) {
    if (this.config.eventCallback !== undefined) {
      this.config.eventCallback(event, {
        trackers: this.config.trackers,
        clientId: this.config.clientId
      });
      return;
    }

    this.config.trackers.forEach(function (tid, index) {
      window.ga("fea" + index + ".send", event);
    });
  };

  GoogleAnalyticsProvider.prototype.tradeInStart = function () {
    this.sendEvent({
      eventAction: "Trade In Start",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.tradeInComplete = function () {
    this.sendEvent({
      eventAction: "Trade In Complete",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.calculationStart = function () {
    this.sendEvent({
      eventAction: "Payment Calculation Start",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.leadFormStart = function () {
    this.sendEvent({
      eventAction: "Lead Start",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.appointmentShown = function () {
    this.sendEvent({
      eventAction: "Appointment Form Shown",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.appointmentStarted = function () {
    this.sendEvent({
      eventAction: "Appointment Started",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.appointmentScheduled = function () {
    this.sendEvent({
      eventAction: "Appointment Scheduled",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.softPullCreditAppStart = function () {
    this.sendEvent({
      eventAction: "Soft Credit App Start",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.softPullCreditAppComplete = function () {
    this.sendEvent({
      eventAction: "Soft Credit App Complete",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.hardPullCreditAppStart = function () {
    this.sendEvent({
      eventAction: "Hard Credit App Start",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.hardPullCreditAppComplete = function () {
    this.sendEvent({
      eventAction: "Hard Credit App Complete",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.reserveVehicleFormStart = function () {
    this.sendEvent({
      eventAction: "Reserve Vehicle Start",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.reserveVehicleFormFinish = function () {
    this.sendEvent({
      eventAction: "Reserve Vehicle Finish",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.savesPayment = function () {
    this.sendEvent({
      eventAction: "Saves Payment",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.signInToGarageGarageIcon = function () {
    this.sendEvent({
      eventAction: "Garage Sign In",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.exploreUpgrades = function () {
    this.sendEvent({
      eventAction: "Explore Upgrades",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.continueDeal = function () {
    this.sendEvent({
      eventAction: "Continue Deal",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.addUpgrade = function () {
    this.sendEvent({
      eventAction: "Add Upgrade",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.buildNewPayment = function () {
    this.sendEvent({
      eventAction: "Build New Payment",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.testDriveShown = function () {
    this.sendEvent({
      eventAction: "Test Drive Form Shown",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.testDriveStarted = function () {
    this.sendEvent({
      eventAction: "Test Drive Form Started",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.testDriveFinished = function () {
    this.sendEvent({
      eventAction: "Test Drive Form Finished",
      eventCategory: "Online Shopper",
      hitType: "event"
    });
  };

  GoogleAnalyticsProvider.prototype.loadGA = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.loaded) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , ga_1.injectScriptToHeadElement(this.config)];

          case 1:
            _a.sent();

            this.loaded = true;
            _a.label = 2;

          case 2:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return GoogleAnalyticsProvider;
}(AnalyticsProvider_1.AnalyticsProvider);

exports.default = GoogleAnalyticsProvider;